module.exports = __webpack_public_path__ + "html/vehicle-table.component.html";